<div>
    <mat-dialog-content>
        <div class="header">
            <div class="rate-txt"> Rate this prompt</div>
            
        </div>
        <div class="body">
            <div class="rating-div">
                <div class="choose-rating">Choose your rating<span *ngIf="isRateRequired" class="required"></span></div>
                <div class="star-div">

                    <svg style="cursor: pointer;" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" *ngFor="let star of [].constructor(5); let i = index" (click)="selectRate(i)" (mouseenter)="handleRationalEnter(i)" (mouseleave)="handleRationalLeave(i)">
                        <g id="Star" clip-path="url(#clip0_2350_44576)">
                        <mask id="mask0_2350_44576" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
                        <rect id="Bounding box" width="32" height="32" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_2350_44576)">
                        <path id="Vector" d="M9.73165 17.0974L5.47289 13.2258L10.8441 12.4584L10.6673 11.221L10.8441 12.4584C11.5315 12.3603 12.135 11.9502 12.4795 11.3474L16 5.18645L19.5205 11.3474C19.865 11.9502 20.4685 12.3603 21.1559 12.4584L26.5271 13.2258L22.2683 17.0974C21.6552 17.6548 21.3981 18.504 21.599 19.3079L23.2419 25.8792L16.9515 22.9437C16.3484 22.6623 15.6516 22.6623 15.0485 22.9437L8.75813 25.8792L10.401 19.3079C10.6019 18.504 10.3448 17.6548 9.73165 17.0974Z"
                         [attr.stroke]="starHover && hoveredRating >= i ? 'black' : selectedrating >= i ?'#FFC832' : 'black'" stroke-width="2.5"
                         [attr.fill]="starHover && hoveredRating >= i ? '#596587' : selectedrating >= i ? '#FFC832' : '#F8F8FC'"/>
                        </g>
                        </g>
                        <defs>
                        <clipPath id="clip0_2350_44576">
                        <rect width="32" height="32" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>
                        

                </div>
                <div class="error" *ngIf="isRateRequired" style="text-align: center;" >
                    <img class="badge" src="/assets/icons/red-Badge.svg"  alt="" /> Rating is mandatory
                </div>
            </div>
            <div class="rational">
                <p>{{ratingRationalData[RationalIndex]}}</p>
            </div>
              <!-- Optional display -->
            <div class="container">
                    <div class="time-container">
                        <button
                        type="button"
                        *ngFor="let item of hourOptions"
                        (click)="add(item.value, item.label)"
                        [ngClass]="{ 'active-timeSaved': selectedHour === item.value }"
                      >
                        {{ item.label }}
                      </button>
                    </div>
                    @if(customSelected){           
                       <div class="time-input">
                       <button type="button" (click)="increment()">+</button>
                     
                       <input
                         type="number"
                         [value]="hours"
                         (input)="onInput($event)"
                         step="1"
                         min="0"
                       />
                     
                       <button type="button" (click)="decrement()">−</button>

                     
                      
                     </div>&nbsp; <span>hour(s)</span>
                    }
                    </div>
            <div class="comments-div" >
                <div class="choose-rating">Comments
                <div *ngIf="isCommentRequired" class="required" ></div>
                </div>
                <textarea [required]="3 >= selectedrating" [(ngModel)]="comments"  (ngModelChange)="checkComments()"></textarea>
                <div class="error" *ngIf="isCommentRequired && (selectedrating <= 2 && comments !=null && comments.length == 0)">
                    <img class="badge" src="/assets/icons/red-Badge.svg" alt=""  /> Comments is mandatory
                </div>
                
            </div>
        </div>
        <div class="btn-div">
            
            <app-button class="button" [type]="'primary'" [buttonType]="'button'" [buttonText]="'Submit'" [disabled]="(selectedrating > -1 && selectedrating < 2)? ((isSubmitDisabled && comments && comments.length ==0) || comments ==null || comments.length == 0 ):isSubmitDisabled" (onClick)="onSubmit($event)"></app-button>


        </div>
    </mat-dialog-content>
</div>